import React from 'react';
import './BbBannerShared.css';

class WelcomeTicketHolder extends React.Component {
  render() {
    console.log('*** WELCOME ***');
    return (
      <div className="container-fluid bg-secondary">
        <div className="row g-0">
          <div className="col center">
            <div id="welcome" className="banner_shared">
              <h4>
                Hello
                {' '}
                {this.props.playerName}
                . Welcome to the private game room
                {' '}
                <span className="bb_private_room">
                  {' '}
                  {this.props.roomName}
                  !
                </span>
              </h4>
              <p>
                The game begins after the room organizer selects a category. If
                the game does not begin soon, contact the organizer to verify
                that this private game is active.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default WelcomeTicketHolder;
